"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TEXT_POSITION = void 0;
const TEXT_POSITION = exports.TEXT_POSITION = 'text-position';
